/**
 * ModuleObjectConstant enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModuleObjectConstant.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModuleObjectConstant {
  OBJECT_INVALID = 0x7f000000,
  PLAYER_ID = 0x7fffffff,
}